/* Titan League - bloque +1 Storage.
   Agrega al MISMO carrito y refresca la pagina, el cajon lateral y el contador
   sin mandar al cliente a otra pantalla. */
(function(){
  if(window.__tlStorageFix4){return;} window.__tlStorageFix4=1;
  var VARIANT=50519870243051;
  var enviando=false;

  function valido(u){
    if(u.length<3||u.length>20) return false;
    if(!/^[A-Za-z0-9_]+$/.test(u)) return false;
    if(u.charAt(0)==='_'||u.charAt(u.length-1)==='_') return false;
    if((u.match(/_/g)||[]).length>1) return false;
    return true;
  }
  function cerca(el,sel){
    while(el&&el!==document){ if(el.nodeType===1&&el.classList&&el.classList.contains(sel)){return el;} el=el.parentNode; }
    return null;
  }
  function decir(caja,t,malo){
    var st=caja?caja.querySelector('.titan-storage-upsell__status'):null;
    if(!st){return;}
    st.textContent=t; st.style.color=malo?'#ff8ea0':'#8ef0b0';
  }
  function destinoDe(id){
    var n=document.getElementById('shopify-section-'+id);
    if(n){ return n; }
    if(id==='cart-drawer'){ return document.querySelector('cart-drawer'); }
    if(id==='cart-icon-bubble'){ return document.getElementById('cart-icon-bubble'); }
    return null;
  }
  function fuenteDe(doc,id){
    return doc.getElementById('shopify-section-'+id)
        || (id==='cart-drawer' ? doc.querySelector('cart-drawer') : null)
        || (id==='cart-icon-bubble' ? doc.getElementById('cart-icon-bubble') : null)
        || doc.body;
  }
  function listaSecciones(){
    var out=[], n=document.querySelectorAll('[id^="shopify-section-"]');
    for(var i=0;i<n.length;i++){
      var id=n[i].id.replace('shopify-section-','');
      if(/cart|header/i.test(id)){ out.push(id); }
    }
    if(document.querySelector('cart-drawer')){ out.push('cart-drawer'); }
    if(document.getElementById('cart-icon-bubble')){ out.push('cart-icon-bubble'); }
    return out;
  }
  function repintar(secs){
    if(!secs){return false;}
    var hubo=false, p=new DOMParser();
    for(var id in secs){
      if(!Object.prototype.hasOwnProperty.call(secs,id)){continue;}
      var destino=destinoDe(id);
      if(!destino){continue;}
      try{
        var doc=p.parseFromString(secs[id],'text/html');
        destino.innerHTML=fuenteDe(doc,id).innerHTML;
        hubo=true;
      }catch(e){}
    }
    return hubo;
  }

  document.addEventListener('click',function(ev){
    var btn=cerca(ev.target,'titan-storage-upsell__add');
    if(!btn){return;}
    var caja=cerca(btn,'titan-storage-upsell');
    if(!caja){return;}
    ev.preventDefault();
    ev.stopPropagation();
    if(ev.stopImmediatePropagation){ev.stopImmediatePropagation();}
    if(enviando){return;}
    var inp=caja.querySelector('.titan-storage-upsell__user');
    var u=inp?(inp.value||'').trim():'';
    if(!u){ decir(caja,'Escribe tu usuario de Roblox.',true); if(inp){inp.focus();} return; }
    if(!valido(u)){ decir(caja,'Ese usuario no parece valido: de 3 a 20 letras o numeros, con un guion bajo como maximo.',true); if(inp){inp.focus();} return; }
    enviando=true; btn.disabled=true; decir(caja,'Agregando...',false);
    var props={};
    props['Articulo seleccionado']='Fruit Storage +1';
    props['Metodo de entrega']='Gifting manual';
    props['Usuario exacto de Roblox']=u;
    var cuerpo={items:[{id:VARIANT,quantity:1,properties:props}]};
    var secs=listaSecciones();
    if(secs.length){ cuerpo.sections=secs.join(','); cuerpo.sections_url=window.location.pathname; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(cuerpo)})
      .then(function(r){ if(!r.ok){ throw 0; } return r.json(); })
      .then(function(d){
        var ok=false;
        try{ ok=repintar(d&&d.sections); }catch(e){ ok=false; }
        if(!ok){ setTimeout(function(){ try{ window.location.reload(); }catch(e){} },600); return; }
        enviando=false;
        try{ document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
      })
      .catch(function(){ enviando=false; btn.disabled=false; decir(caja,'No pudimos agregarlo. Intenta de nuevo en un momento.',true); });
  }, true);

  document.addEventListener('input',function(ev){
    var inp=ev.target;
    if(!inp||!inp.classList||!inp.classList.contains('titan-storage-upsell__user')){return;}
    var caja=cerca(inp,'titan-storage-upsell');
    var st=caja?caja.querySelector('.titan-storage-upsell__status'):null;
    if(st&&st.textContent){ st.textContent=''; }
  }, true);
})();